import { Component, ElementRef, OnInit } from '@angular/core'
import { NavbarService } from '../services/navbar.service'
import { trigger, transition, style, animate, state, AnimationBuilder } from '@angular/animations'

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
  animations: [
    trigger('income', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('1500ms', style({ opacity: 0 }))
      ])
    ]),
    trigger('scaleInOut', [
      state('initial', style({
        transform: 'scale(1)'
      })),
      state('final', style({
        transform: 'scale(1.5)'
      })),
      transition('initial=>final', animate('300ms')),
      transition('final=>initial', animate('200ms'))
    ]),
    trigger('slideInRight', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0%)' }))
      ])
    ]),
    trigger('slideInTop', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('300ms ease-out', style({ transform: 'translateY(0%)' }))
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('2300ms ease-out', style({ opacity: 1 }))
      ])
    ])
  ]
})

export class AboutComponent implements OnInit {
  sectionId: string
  register: boolean = true

  constructor(public navbarService: NavbarService,
    public elementRef: ElementRef,
    private animationBuilder: AnimationBuilder
  ) { }

  ngOnInit(): void {
    this.navbarService.showNavbar = true
  }

  onInView({ inView, element }: { inView: boolean, element: ElementRef }) {
    if (inView) {
      const anim = element.nativeElement
      const animation = this.animationBuilder.build([
        style({ opacity: 0, transform: 'translateY(100px)' }),
        animate('1s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
      // Check if the animation has already been played
      if (!anim.classList.contains('played')) {
        anim.classList.add('played') // Add a class to mark the element as played
        animation.create(anim).play()
      }
    }
  }

  slideFromRight({ inView, element }: { inView: boolean, element: ElementRef }) {
    if (inView) {
      const anim = element.nativeElement
      const animation = this.animationBuilder.build([
        style({ transform: 'translateX(100%)' }),
        animate('1s ease-out', style({ transform: 'translateX(0%)' }))
      ])
      // Check if the animation has already been played
      if (!anim.classList.contains('played')) {
        anim.classList.add('played') // Add a class to mark the element as played
        animation.create(anim).play()
      }
    }
  }

  slideFromLeft({ inView, element }: { inView: boolean, element: ElementRef }) {
    const anim = element.nativeElement

    if (inView) {
      const animation = this.animationBuilder.build([
        style({ transform: 'translateX(-100%)' }),
        animate('1s ease-in-out', style({ transform: 'translateX(0%)' }))
      ])

      // Check if the animation has already been played
      if (!anim.classList.contains('played')) {
        anim.classList.add('played') // Add a class to mark the element as played
        animation.create(anim).play()
      }
    }
  }

  fadeIn({ inView, element }: { inView: boolean, element: ElementRef }) {
    const anim = element.nativeElement

    if (inView) {
      const animation = this.animationBuilder.build([
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 }))
      ])

      // Check if the animation has already been played
      if (!anim.classList.contains('played')) {
        anim.classList.add('played') // Add a class to mark the element as played
        animation.create(anim).play()
      }
    }
  }

  slideFromTop({ inView, element }: { inView: boolean, element: ElementRef }) {
    const anim = element.nativeElement

    if (inView) {
      const animation = this.animationBuilder.build([
        style({ transform: 'translateY(-100%)' }),
        animate('1s ease-out', style({ transform: 'translateY(0%)' }))
      ])

      // Check if the animation has already been played
      if (!anim.classList.contains('played')) {
        anim.classList.add('played') // Add a class to mark the element as played
        animation.create(anim).play()
      }
    }
  }
}